<template>
	<div>
		<div @mousemove="move" class="w3l-banner">
			<div :style="'transform: translate(' +
			(position == 'left' ? '20' : '-20') +
			'px,' +
			(position2 == 'top' ? '10' : '-10') +
			'px) scale(1.1)'
			" class="banner-image"></div>
			<div class="titleBox" :class="contType == 'e' ? 'titleBoxe' : ''">


			</div>
		</div>

		<div class="twoSectionBoxStyle">
			<div class="twoSectionTitleBoxStyle" v-if="contType == 'z'">
				<div class="wow bounceInUp twoTitleT1Style">反洗钱与反恐融资声明</div>
				<div class="wow bounceInUp twoTitleT2Style">
					<p class="t">1. 介绍</p>
					<p>索图科技技术有限公司（“索图科技”）致力于最高标准的反洗钱（AML）和反恐融资（CTF）合规。我们遵守香港及全球所有相关法律法规，以防止和检测任何与洗钱和恐怖融资有关的活动。</p>
					<p class="t">2. 政策声明</p>
					<p>索图科技已实施全面的政策和程序，旨在防止洗钱和恐怖融资。这些政策符合香港海关（CED）和其他相关监管机构的要求。</p>
					<p class="t">3. 客户尽职调查（CDD）</p>
					<p>我们进行彻底的客户尽职调查（CDD）措施，以验证客户的身份并评估每个客户关系的风险。这包括：</p>
					<ul style="margin-left:20px">
						<li style="text-indent: 0;">
							使用可靠、独立的来源文件、数据或信息识别和验证客户身份。</li>
						<li style="text-indent: 0;">了解并在适当时获取业务关系的目的和预期性质的信息。</li>
						<li style="text-indent: 0;">对业务关系进行持续监控，以确保交易符合我们对客户及其风险状况的了解。</li>
					</ul>
					<p class="t">4. 记录保存</p>
					<p>我们根据法律要求，保存所有交易和客户识别信息的全面记录，至少保留一段时间。这些记录被安全地保存，并可随时供监管审查。</p>
					<p class="t">5. 可疑活动报告</p>
					<p>索图科技已建立及时向相关当局报告可疑活动的程序。员工接受培训，能够识别和报告可能表明洗钱或恐怖融资的可疑活动。</p>
					<p class="t">6. 培训与意识</p>
					<p>索图科技的所有员工定期接受有关AML和CTF政策、程序和法规的培训。此培训确保员工了解其职责，并具备检测和报告可疑活动的能力。</p>
					<p class="t">7. 合规与监控</p>
					<p>我们有专门的合规团队负责监控我们的AML和CTF政策和程序。该团队定期进行审计和评估，以确保符合所有适用的法律和法规。</p>
					<p class="t">8. 结论</p>
					<p>索图科技致力于维护金融系统的完整性，防止洗钱和恐怖融资。我们将继续审查和更新我们的AML和CTF政策，以确保其有效性并符合监管要求。</p>
					<p class="t">联系信息</p>
					<p>如果您对我们的AML和CTF政策有任何疑问，请通过以下方式联系我们：</p>
					<p>电子邮件：compliance@suntone.com </p>
					<p>地址：索图科技技术有限公司</p>
					<p>香港特别行政区鲗鱼涌英皇道728号K11 Atelier 五楼545</p>
					<p><br></p>
				</div>
			</div>
			<div class="twoSectionTitleBoxStyle" v-if="contType == 'f'">
				<div class="wow bounceInUp twoTitleT1Style">反洗錢與反恐融資聲明</div>
				<div class="wow bounceInUp twoTitleT2Style">
					<p class="t">1. 介紹</p>
					<p>索圖科技技術有限公司（「索圖科技」）致力於最高標準的反洗錢（AML）和反恐融資（CTF）合規。我們遵守香港及全球所有相關法律法規，以防止和檢測任何與洗錢和恐怖融資有關的活動。</p>
					<p class="t">2. 政策聲明</p>
					<p>索圖科技已實施全面的政策和程序，旨在防止洗錢和恐怖融資。這些政策符合香港海關（CED）和其他相關監管機構的要求。</p>
					<p class="t">3. 客戶盡職調查（CDD）</p>
					<p>我們進行徹底的客戶盡職調查（CDD）措施，以驗證客戶的身份並評估每個客戶關系的風險。這包括：</p>
					<ul style="margin-left:20px">
						<li style="text-indent: 0;">
							使用可靠、獨立的來源文件、數據或信息識別和驗證客戶身份。</li>
						<li style="text-indent: 0;">了解並在適當時獲取業務關系的目的和預期性質的信息。</li>
						<li style="text-indent: 0;">對業務關系進行持續監控，以確保交易符合我們對客戶及其風險狀況的了解。</li>

					</ul>
					<p class="t">4. 記錄保存</p>
					<p>我們根據法律要求，保存所有交易和客戶識別信息的全面記錄，至少保留一段時間。這些記錄被安全地保存，並可隨時供監管審查。</p>
					<p class="t">5. 可疑活動報告</p>
					<p>索圖科技已建立及時向相關當局報告可疑活動的程序。員工接受培訓，能夠識別和報告可能表明洗錢或恐怖融資的可疑活動。</p>
					<p class="t">6. 培訓與意識</p>
					<p>索圖科技的所有員工定期接受有關AML和CTF政策、程序和法規的培訓。此培訓確保員工了解其職責，並具備檢測和報告可疑活動的能力。</p>
					<p class="t">7. 合規與監控</p>
					<p>我們有專門的合規團隊負責監控我們的AML和CTF政策和程序。該團隊定期進行審計和評估，以確保符合所有適用的法律和法規。</p>
					<p class="t">8. 結論</p>
					<p>索圖科技致力於維護金融系統的完整性，防止洗錢和恐怖融資。我們將繼續審查和更新我們的AML和CTF政策，以確保其有效性並符合監管要求。</p>
					<p class="t">聯系信息</p>
					<p>如果您對我們的AML和CTF政策有任何疑問，請通過以下方式聯系我們：</p>
					<p>電子郵件：compliance@suntone.com </p>
					<p>地址：索圖科技技術有限公司</p>
					<p>香港特別行政區鲗魚涌英皇道728號K11 Atelier 五樓545</p>
					<p><br></p>

				</div>
			</div>
			<div class="twoSectionTitleBoxStyle" v-if="contType == 'e'">

				<div class="wow bounceInUp twoTitleT1Style">Anti-Money Laundering and Counter-Terrorist Financing
					Statement </div>
				<div class="wow bounceInUp twoTitleT2Style">
					<p class="t">1. Introduction</p>
					<p>Suntone Technology Co., Limited ("Suntone Technology") is committed to the highest standards of
						anti-money laundering (AML) and counter-terrorist financing (CTF) compliance. We adhere to all
						relevant laws and regulations in Hong Kong and globally to prevent and detect any activities
						related to money laundering and terrorist financing.</p>
					<p class="t">2. Policy Statement</p>
					<p>Suntone Technology has implemented comprehensive policies and procedures designed to prevent
						money laundering and terrorist financing. These policies are in line with the requirements set
						forth by the Hong Kong Customs and Excise Department</p>
					<p> (CED) and other relevant regulatory bodies.</p>
					<p class="t">3. Customer Due Diligence (CDD)</p>
					<p>We conduct thorough customer due diligence (CDD) measures to verify the identity of our customers
						and assess the risks associated with each customer relationship. This includes:</p>
					<ul style="margin-left:20px">
						<li style="text-indent: 0;">Identifying and verifying the identity of customers using reliable,
							independent source
							documents, data, or information.</li>
						<li style="text-indent: 0;">Understanding and, as appropriate, obtaining information on the
							purpose and intended
							nature of the business relationship.</li>
						<li style="text-indent: 0;">Conducting ongoing monitoring of the business relationship to ensure
							that transactions
							are consistent with our knowledge of the customer and their risk profile.</li>
					</ul>
					<p class="t">4. Record Keeping</p>
					<p>We maintain comprehensive records of all transactions and customer identification information for
						a minimum period as required by law. These records are kept securely and are readily accessible
						for regulatory review.</p>
					<p class="t">5. Reporting Suspicious Activities</p>
					<p>Suntone Technology has established procedures for the timely reporting of suspicious activities
						to the relevant authorities. Employees are trained to recognize and report any suspicious
						activities that may indicate money laundering or terrorist financing.</p>
					<p class="t">6. Training and Awareness</p>
					<p>All employees of Suntone Technology receive regular training on AML and CTF policies, procedures,
						and regulations. This training ensures that employees are aware of their responsibilities and
						are equipped to detect and report suspicious activities.</p>
					<p class="t">7. Compliance and Monitoring</p>
					<p>We have a dedicated compliance team responsible for monitoring our AML and CTF policies and
						procedures. This team conducts regular audits and reviews to ensure compliance with all
						applicable laws and regulations.</p>
					<p class="t">8. Conclusion</p>
					<p>Suntone Technology is committed to maintaining the integrity of the financial system and
						preventing money laundering and terrorist financing. We will continue to review and update our
						AML and CTF policies to ensure they remain effective and in line with regulatory requirements.
					</p>
					<p class="t">Contact Information</p>
					<p>If you have any questions regarding our AML and CTF policies, please contact us at: </p>
					<p>Email: compliance@suntone.com </p>
					<p>Address: </p>
					<p>Suntone Technology Co., Limited</p>
					<p>Room 545,5/F, K11 Atelier, 728 King's Road.Quarry Bay, Hong Kong</p>
					<p><br></p>
				</div>
			</div>

		</div>






	</div>
</template>
<!-- <script src="https://smtpjs.com/v3/smtp.js"></script> -->
<script>


import { Email } from "../utils/smtp.js";
import { WOW } from "wowjs";

export default {
	name: "index",
	data: (vm) => {
		return {
			bodyW: 0,
			bodyY: 0,
			position: "",
			position2: "",
			contList: {
			},
			contType: "z",

		};
	},
	methods: {
		move(e) {
			if (e.pageX > this.bodyW / 2) {
				this.position = "right";
			} else {
				this.position = "left";
			}
			if (e.pageY > 250) {
				this.position2 = "top";
			} else {
				this.position2 = "bottom";
			}
		},
		changeTypeTitleName() {
			if (this.contType == "f") {
				document.title = "反洗錢與反恐融資聲明";
			} else if (this.contType == 'e') {
				document.title = 'Anti-Money Laundering and Counter-Terrorist Financing Statement'
			} else {
				document.title = "反洗钱与反恐融资声明";
			}
		}

	},

	mounted() {
		this.bodyW = document.body.clientWidth;
		this.bodyY = document.body.clientHeight;
		var that = this;
		this.contType = window.localStorage.getItem('language');
		that.changeTypeTitleName()
		window.addEventListener('setItemEvent', function (e) {
			if (e.key == "language") {
				that.contType = e.newValue;
				that.changeTypeTitleName()
			}
		})
		var wow = new WOW({
			boxClass: "wow",
			animateClass: "animated",
			offset: 40,
			mobile: true,
			live: true,
		});
		wow.init();
		//QOFGPGRDUUMNZALE


	},
};
</script>

<style src="../assets/css/AboutUs-pc.css" scoped></style>
<style src="../assets/css/AboutUs-phone.css" scoped></style>
<style scoped>
.titleBox {
	padding-top: 0px;
}

.w3l-banner {
	height: 130px;
}

.twoTitleT2Style {
	display: block;
	max-width: 1120px;
}

p {
	text-indent: 0%;
}

.twoTitleT2Style ul li {
	text-indent: none;
}

.t {
	margin-top: 10px;
	font-weight: 700;
}

@media screen and (min-width: 801px) {
	p {
		text-indent: 0%;
	}

	.twoTitleT2Style ul li {
		text-indent: none;
	}
}
</style>
<!-- </style> -->
